import React from 'react';
import Seo from '@/components/Seo';
import ContactUs from '@/components/contact-us/ContactUs.tsx';
import { contactContent } from '@/content/contact';

/**
 * Standalone "Contact" page, linked from the navbar's "Contact Us" entry
 * (see `siteConfig.pages`). Reuses the home page's `ContactUs` section
 * component as-is (which itself composes `ContactDetails` + `ContactForm`),
 * so the contact content/markup stays in sync wherever it's rendered.
 */
const Contact: React.FC = () => {
    return (
        <>
            <Seo title={contactContent.sectionTitle} path="/contact" breadcrumbs={[]} />
            <ContactUs />
        </>
    );
};

export default Contact;
